module.exports = __webpack_public_path__ + "static/img/20.fd72ef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/20.jpg
// module id = 1Q35
// module chunks = 1